import { CustomPopover } from 'components';
import { PopoverArrowTypes } from 'constants/common';
import { FC, useState } from 'react';
import { calculatePercentageChange } from '../utils';
import { ProjectionData } from '../home.model';
import { getAmountWithCurrency } from 'utils/amountUtils';

interface AmountPercentageToolTipProps {
  width?: string;
  minWidth?: string;
  arrowOffset?: string;
  offset?: string;
  futureProjection: ProjectionData;
  pastProjection: ProjectionData;
}

const AmountPercentageToolTip: FC<AmountPercentageToolTipProps> = ({
  futureProjection,
  pastProjection,
  width = 'w-[170px]',
  minWidth = 'min-w-[15px]',
  arrowOffset = 'right-2 left-5',
  offset = 'left-1'
}) => {
  const [showToolTip, setShowToolTip] = useState(false);

  const handleShowToolTip = () => {
    setShowToolTip(true);
  };

  const handleCloseToolTip = () => {
    setShowToolTip(false);
  };

  const toolTipElement = () => (
    <div
      onMouseEnter={handleShowToolTip}
      onMouseLeave={handleCloseToolTip}
      className={`ml-1 flex h-[18px] items-center justify-center rounded px-1.5 text-px13 
              ${
                pastProjection.amount < futureProjection.amount ? 'bg-green-1 text-green-2' : 'bg-error/20 text-error'
              }`}>
      {calculatePercentageChange(pastProjection.amount, futureProjection.amount)}
    </div>
  );
  return (
    <CustomPopover
      show={showToolTip}
      onTogglePopover={handleShowToolTip}
      onClosePopover={handleCloseToolTip}
      anchorComponent={toolTipElement}
      highlightAnchor={false}
      offset={offset}
      popoverBodyStyle="px-2 py-1"
      showArrow={true}
      arrowType={PopoverArrowTypes.BOTTOM}
      arrowOffset={arrowOffset}
      margin="mt-3"
      minWidth={minWidth}
      width={width}
      showOnTop={true}>
      <div className="text-sbase text-primaryText">
        {`
        vs. ${getAmountWithCurrency(pastProjection.amount)} in last 7 days
      `}
      </div>
    </CustomPopover>
  );
};

export default AmountPercentageToolTip;
